import fetchServices from "./FetchServices";
import ApiConstants from "../Utils/ApiConstant";
import {
  setFYEList,
  setUniqueBuildingAccManager,
  setUniqueFYEDate,
  setFYInternalReviewStatus,
  setUniqueAccountingMethod,
} from "../Store/Readux/Reducer/FinancialYearEndSlice";
import { hideLoader, showLoader } from "../Store/Readux/Reducer/LoaderSlice";

export const getFYEData = () => async (dispatch, getState) => {
  dispatch(showLoader());
  try {
    let URL = ApiConstants.financialYearEndListURL;
    const method = "GET";
    const response = await fetchServices(URL, method, {});
    if (response.status_code === 200) {
      dispatch(setFYEList(response.data.buildingData));
      dispatch(setUniqueBuildingAccManager(response.data.uniqueAccountManager));
      dispatch(setUniqueFYEDate(response.data.uniqueFYEDate));
      dispatch(setFYInternalReviewStatus(response.data.fyInternalReviewStatus));
      dispatch(setUniqueAccountingMethod(response.data.uniqueAccountingMethod));
    }
    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};

export const storeFinancialYearEndDetails =
  (requestBody) => async (dispatch, getState) => {
    dispatch(showLoader());
    try {
      let URL = ApiConstants.financialYearEndStoreURL;
      const method = "POST";
      const response = await fetchServices(URL, method, requestBody);
      return response;
    } catch (error) {
      throw error;
    } finally {
      dispatch(hideLoader());
    }
  };

export const syncAuditorName = (requestBody) => async (dispatch, getState) => {
  try {
    let URL = ApiConstants.syncAuditorNameURL;
    const method = "POST";
    const response = await fetchServices(
      dispatch,
      URL,
      method,
      requestBody,
    );

    return response;
  } catch (error) {
    throw error;
  }
};
